import { type ApiClientResponse, apiClient, routes } from 'common/services';

type EventFeedbackRequestData = {
  audio_rating?: number;
  audio_text?: string;
  helpful_rating?: number;
  helpful_text?: string;
  provider_rating?: number;
  provider_text?: string;
  recommend_rating?: number;
  recommend_text?: string;
  video_rating?: number;
  video_text?: string;
};

/* eslint-disable @typescript-eslint/naming-convention -- Start: We missing correct application model in camelCase, we need to fix it */
export const createEventFeedback = async (id: string, data: EventFeedbackRequestData) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.events.createFeedback(id), {
    events_feedback: data,
  });
/* eslint-enable @typescript-eslint/naming-convention -- End: We missing correct application model in camelCase, we need to fix it */
